export const selectContainerTheme = (paramTheme:string) => {
  return paramTheme === "dark"
  ? paramTheme
  : paramTheme === "white"
  ? "light"
  : "dark";
};
